import Tracking from "../types/Tracking";

// Order want entries by their manual priority (lower first); unprioritized
// entries (null) fall to the bottom, newest first.
export const byPriority = (a: Tracking, b: Tracking): number => {
  if (a.priority !== null && b.priority !== null)
    return a.priority - b.priority;
  if (a.priority !== null) return -1;
  if (b.priority !== null) return 1;
  return (b.updatedAt ?? "").localeCompare(a.updatedAt ?? "");
};
